import { Saga } from 'redux-saga';
import { fork } from 'redux-saga/effects';

export const forkList = (sagasList: Saga[]) => sagasList.map(fork);
